import React from "react";
import "../../assets/scss/headerOnlyLogo.scss";
import Logo from "../../assets/images/smartStudyLogo.svg";

const HeaderLogo = () => {
    return (
        <div className="headerOnly">
            <div className="headerLogoDiv">
                <div className="rounded mx-auto d-block">
                    <a href="/">
                        <img src={Logo} alt="logo" className="headerLogo"></img>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HeaderLogo;
